function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9171 7.03246C15.7712 6.71898 15.4568 6.5185 15.1111 6.5185H10.2118L13.4906 1.3661C13.6648 1.09238 13.676 0.745538 13.5199 0.461154C13.3638 0.176769 13.0651 0 12.7407 0H7.40738C7.09017 0 6.79701 0.169007 6.63814 0.443495L0.119637 11.7027C-0.0395921 11.9777 -0.0398885 12.3168 0.118807 12.5921C0.277563 12.8674 0.571133 13.037 0.88888 13.037H6.24359L4.77201 18.4327C4.6622 18.8353 4.84721 19.26 5.21669 19.4538C5.34754 19.5224 5.48905 19.5555 5.62919 19.5555C5.88478 19.5555 6.13598 19.4453 6.30949 19.2391L15.7909 7.97989C16.0137 7.71548 16.0629 7.34588 15.9171 7.03246ZM7.54895 15.0075L8.26498 12.382C8.33787 12.1148 8.28199 11.8288 8.11381 11.6086C7.94563 11.3884 7.68442 11.2592 7.40738 11.2592H2.43062L7.91991 1.77777H11.1214L7.84264 6.93018C7.66854 7.20389 7.65728 7.55074 7.81337 7.83518C7.96951 8.11951 8.26818 8.29628 8.59257 8.29628H13.2005L7.54895 15.0075Z",
  fill: "black"
});

var SvgBolt = function SvgBolt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBolt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bolt.f0425db4.svg";
export { ForwardRef as ReactComponent };